export var PresenceStatus;
(function (PresenceStatus) {
    PresenceStatus["UNKNOWN"] = "UNKNOWN";
    PresenceStatus["ACTIVE"] = "ACTIVE";
    PresenceStatus["OFFLINE"] = "OFFLINE";
})(PresenceStatus || (PresenceStatus = {}));
export var DeviceType;
(function (DeviceType) {
    DeviceType["UNKNOWN"] = "UNKNOWN";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE"] = "MOBILE";
})(DeviceType || (DeviceType = {}));
export var Scope;
(function (Scope) {
    Scope["UNDEFINED"] = "UNDEFINED";
    Scope["VIEWER"] = "VIEWER";
    Scope["EDITOR_X"] = "EDITOR_X";
})(Scope || (Scope = {}));
//# sourceMappingURL=types.js.map